<template>
    <v-list class="list_container">
        <slot></slot>
    </v-list>
</template>

<script>
export default {
    name: "List",
}
</script>

<style lang="scss" scoped>
.list_container {
    max-height: 600px;
    height: 100%;
    overflow: auto;
    border-radius: 4px;

    ::v-deep .v-list-item {
        min-height: 44px;
        height: 44px;

        &.active {
            //color: $ada_blue;
            color: #00698b;
            background-color: rgba(0, 182, 237, 0.13);
        }

        &:not(.active):hover {
            cursor: pointer;
            background: #f9f9f9;
        }
    }

    ::v-deep .v-list-item__icon {
        margin: 10px 0;

        .v-icon.deleteIcon:hover {
            color: $ada_red !important;
        }
    }
}
</style>